import { GET_CRBWP_FAILURE, GET_CRBWP_REQUEST, GET_CRBWP_SUCCESS } from "./constants";

export interface IState {
    startDate: Date;
    stopDate: Date;
    gotData: boolean;
    loading: boolean;
    error: null | string;
    data: any;
}

export const initialState: any = {
    gotData: false,
    loading: false,
    error: null,
    startDate: new Date(),
    stopDate: new Date(),
    scoreData: [],
};

export const CRBWPReducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case GET_CRBWP_REQUEST:
            return {
                ...state,
                gotData: false,
                loading: true,
                error: null,
            };
        case GET_CRBWP_SUCCESS:

            const newState = {
                ...state,
                loading: false,
                gotData: true,
                scoreData: action.payload.scoreData,
            };

            return newState;

        case GET_CRBWP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
